import * as angular from "angular";
import {IController} from "angular";

export class ProgramLocationsByPackageSizeTableComponent implements IController {

  accountId: string;
  locations: any;
  excludeLocationIds: any;
  packagesOptionsIds: string[];
  onUpdateLocation: Function;
  onDeleteLocation: Function;
  onBulkEditLocation: Function;
  onCreateCustomer: Function;

  /* @ngInject */
  constructor() {
  }

  $onInit() {

  };

  $onChanges(changes) {

  };


  /////////////////////////////////////////////////////////////////////



}

angular
  .module('bringoz.admin.pricePlan')
  .component('programLocationsByPackageSizeTable', {
    require: {
      form: '^form'
    },
    bindings: {
      accountId: '<?',
      locations: '<',
      excludeLocationIds: '<?',
      packagesOptionsIds: '<',
      onUpdateLocation: '&',
      onDeleteLocation: '&',
      onBulkEditLocation: '&',
      onCreateCustomer: '&'
    },
    template: require('./program-locations-by-package-size-table.html').default,
    controller: ProgramLocationsByPackageSizeTableComponent
  });
